import React, { useState, useEffect } from 'react';
import { 
  Box, 
  Typography, 
  TextField,
  InputAdornment,
  Tooltip,
  IconButton
} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

export const VendorSummaryBox = ({ vendor, total, color }) => {
  const [discount, setDiscount] = useState('0');
  const [discountedTotal, setDiscountedTotal] = useState(total);

  const handleDiscountChange = (event) => {
    const value = event.target.value;
    if (/^\d{0,2}$/.test(value)) {
      setDiscount(value);
    }
  };

  const handleClear = () => {
    setDiscount('0');
  };

  useEffect(() => {
    const discountPercent = parseInt(discount || '0', 10);
    const discountMultiplier = (100 - discountPercent) / 100;
    setDiscountedTotal(total * discountMultiplier);
  }, [discount, total]);

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  return (
    <Box
      sx={{
        width: '100%',
        p: 2.5,
        mb: 1,
        borderRadius: 1,
        backgroundColor: 'white',
        border: 1,
        borderColor: color,
        boxShadow: 1,
      }}
    >
      <Typography
        variant="h4"
        sx={{
          color: color,
          fontWeight: 800,
          mb: 1.5,
          textAlign: 'center'
        }}
      >
        {vendor}
      </Typography>
      
      <Box 
        sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          gap: 1, 
          mb: 2 
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <TextField
            size="small"
            value={discount}
            onChange={handleDiscountChange}
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            sx={{
              width: '100px',
              '& .MuiInputBase-input': {
                py: 0.75,
                textAlign: 'right',
                fontSize: '1.1rem'
              },
            }}
            placeholder="0"
          />
          <Typography variant="body1" color="text.secondary">
            discount
          </Typography>
          {discount !== '0' && (
            <Tooltip title="Clear discount">
              <IconButton 
                size="small" 
                onClick={handleClear}
                sx={{ 
                  p: 0.5,
                  '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)'
                  }
                }}
              >
                <ClearIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      </Box>

      <Box sx={{ textAlign: 'center' }}>
        {discount !== '0' && (
          <Typography 
            variant="h5" 
            sx={{ 
              textDecoration: 'line-through',
              color: 'text.secondary',
              mb: 1
            }}
          >
            {formatCurrency(total)}
          </Typography>
        )}
        <Tooltip title={discount !== '0' ? `${discount}% discount applied` : ''}>
          <Typography variant="h3" sx={{ fontWeight: 'bold' }}>
            {formatCurrency(discountedTotal)}
          </Typography>
        </Tooltip>
      </Box>
    </Box>
  );
};